angular
	.module 'App.Module.Subscriber', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'subscriber',
				url: '/subscriptions',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@subscriber":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'SubscriberSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.Setting.Subscription.Enabled'
					searchParams:
						createEnabled: false
						filterEnabled: false
						translateItem: true
						redirectOnEmpty: true
						title: 'wbo.subscriptions'

			.state 'subscriber.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					subscribers: (SubscriberRepository, $stateParams) ->
						query = SubscriberRepository.createQuery()
						query.criteria 'entity_type', '=', $stateParams.id
						query.with('shop', 'register')

						return SubscriberRepository.getEntities(query)

			.state 'subscriber.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'SubscriberController'
						controllerAs: 'vm'
						templateUrl: '@app/subscriber/subscriber.view.html'
